import { FilterStoreScope } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';

/**
 * Check if two filter store scopes are the same.
 * @param a
 * @param b
 */
export const isSameFilterStoreScope = (
  a: FilterStoreScope,
  b: FilterStoreScope,
): boolean =>
  a.organizationId === b.organizationId &&
  a.databaseId === b.databaseId &&
  a.databaseRevisionId === b.databaseRevisionId &&
  a.scopeName === b.scopeName;
